import resolver, {ResolverSettings} from './utils/resolver';

class GuestFormAdditionalDataApi {
  ENDPOINTS = {
    getPurposeOfStay: (params = '') => `purposes-of-stay/?${params}`,
  };

  getPurposeOfStay(resolverSettings?: ResolverSettings) {
    return resolver<{id: string; name: string}[]>(
      this.ENDPOINTS.getPurposeOfStay(),
      null,
      resolverSettings,
    );
  }
}

export {GuestFormAdditionalDataApi};
